module.exports = __webpack_public_path__ + "img/add&new-icon.6f14424d.svg";